import React from 'react';
import { NavLink } from 'react-router-dom';
import SignOut from '../../pages/authentication/sign-out/SignOut';

export default function CourierNavbarLinksDesktop(): JSX.Element {
  return (
    <div className="desktop-only">
      <div className="navbar__nav-links">
        <div className="navbar__nav-links">
          <NavLink
            to="/my-shift"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            Shift
          </NavLink>
          <NavLink
            to="/hub"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            Hub
          </NavLink>
          <NavLink
            to="/my-deliveries"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            My deliveries
          </NavLink>
          <NavLink
            to="/my-deliveries-old"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            My deliveries (old)
          </NavLink>
          <NavLink
            to="/my-tips"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            Tips&Help
          </NavLink>
          <NavLink
            to="/my-rating"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            My Rating
          </NavLink>
          <NavLink
            to="/my-rating-old"
            activeClassName="navbar__active-link"
            className="navbar__link"
          >
            My Rating (old)
          </NavLink>
        </div>
        <SignOut />
      </div>
    </div>
  );
}
